
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import FormError from '@/components/FormError.vue';

const EmailReceiptParams = Vue.extend({
	inject: ['$validator'],
	components: {
		FormError,
	},
	computed: {
		...mapState('claimCheck', ['claimCheck']),
	},
	methods: {
		...mapActions('claimCheck', ['sendReceipt']),
	},
});

@Component
export default class EmailReceiptModal extends EmailReceiptParams {
	public email: string = '';
	public emailErrors: any = null;

	public created() {
		if (this.claimCheck.email) {
			this.email = this.claimCheck.email;
		}
	}

	public async emailReceipt() {
		(this as any).errors.clear();

		if (!await this.$validator.validate()) {
			return false;
		}

		try {
			await this.sendReceipt({
				email: this.email,
				ticket: this.claimCheck.ticket,
				url: `/claim/${this.claimCheck.ticket}/email-receipt`,
			});
			this.$modal.hide('EmailReceiptModal');
		} catch (errors: any) {
			this.emailErrors = errors.response;
		}
	}
}
